export default "__VITE_ASSET__c1703466__"